import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import styled from 'styled-components';
import { space, width, height, typography, color } from 'styled-system';

var H = /*#__PURE__*/styled.h3.withConfig({
  componentId: "hpgkwz-0"
})(["font-weight:unset;font-size:unset;line-height:unset;margin:0;padding:0;", " ", " ", " ", " ", ""], space, width, height, typography, color);

var DSHeader = function DSHeader(_ref) {
  var color = _ref.color,
      fontFamily = _ref.fontFamily,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      height = _ref.height,
      level = _ref.level,
      lineHeight = _ref.lineHeight,
      text = _ref.text,
      width = _ref.width,
      rest = _objectWithoutProperties(_ref, ["color", "fontFamily", "fontSize", "fontWeight", "height", "level", "lineHeight", "text", "width"]);

  return /*#__PURE__*/React.createElement(H, _extends({
    as: "h".concat(level),
    color: color,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeight: fontWeight,
    height: height,
    lineHeight: lineHeight,
    width: width,
    "data-testid": "em-ds-header"
  }, rest), text);
};

DSHeader.defaultProps = {
  level: 3,
  lineHeight: 1.2
};
var headerProps = {
  color: PropTypes.string.description('Colors aliases from theme. I.e. `brand.400`'),
  fontFamily: PropTypes.string.description('font-family aliases from theme. I.e. `default`'),
  fontSize: PropTypes.string.description('any valid value format. I.e. `16px`'),
  fontWeight: PropTypes.string.description('any alias from theme. I.e. `semibold`'),
  height: PropTypes.string.description('any valid value format. I.e. `200px`'),
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]).description('Depth of header tag. I.e. level `2` renders a h2 tag').defaultValue(2),
  lineHeight: PropTypes.number.description('float numbers for line-height. I.e. 1.5').defaultValue(1.2),
  m: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']).description('margin'),
  mb: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']).description('margin-bottom'),
  ml: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']).description('margin-left'),
  mr: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']).description('margin-right'),
  mt: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']).description('margin-top'),
  mx: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']).description('margin x'),
  my: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']).description('margin y'),
  p: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']).description('padding'),
  pb: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']).description('padding-bottom'),
  pl: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']).description('padding-left'),
  pr: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']).description('padding-right'),
  pt: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']).description('padding-top'),
  px: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']).description('padding x'),
  py: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']).description('padding y'),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).description('Header s text').isRequired,
  width: PropTypes.string.description('text width')
};
DSHeader.propTypes = headerProps;
var HeaderWithSchema = describe(DSHeader);
HeaderWithSchema.propTypes = headerProps;

export default DSHeader;
export { DSHeader, HeaderWithSchema };
//# sourceMappingURL=Header.js.map
